import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const StoreCustomerMembershipsPage = () => {
  const { storeId } = useParams();

  return <Navigate to={`/management/stores/${storeId}/membership-plans?tab=customer-memberships`} replace />;
};

export default StoreCustomerMembershipsPage;
